module.exports = __webpack_public_path__ + "img/7f444b8a913bc87744b0c2f9acfcbeaa60aad30f.033823a4.jpg";